module.exports = __webpack_public_path__ + "img/carbon_airline-passenger-care.2746c486.svg";